import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, HeartIcon, RocketIcon } from 'lucide-react';
const outcomes = [{
  icon: BrainIcon,
  title: 'Comprender cómo funciona tu mente',
  description: 'Descubrí cómo se forman las emociones, los pensamientos automáticos y los hábitos que influyen en tu bienestar diario.'
}, {
  icon: HeartIcon,
  title: 'Aprender a gestionar tus emociones',
  description: 'Desarrollá habilidades para afrontar el estrés, la ansiedad y las dificultades cotidianas con mayor equilibrio y claridad.'
}, {
  icon: RocketIcon,
  title: 'Construir una versión más segura de vos mismo',
  description: 'Fortalecé tu autoestima, transformá patrones limitantes y desarrollá una identidad más consciente y resiliente.'
}];
export function PainPoints() {
  return <section className="bg-paper px-4 py-20 md:py-28" data-id="element-150" data-mp="3id32s2x4lk4o">
      <div className="mx-auto max-w-6xl" data-id="element-151" data-mp="3iee3ftv9ybrk">
        <div className="mx-auto max-w-2xl text-center" data-id="element-152" data-mp="3nd7ktxdommx0">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-clay-dark" data-id="element-153" data-mp="3nbwf3s0of539">El cambio empieza por entenderte</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-154" data-mp="1u1lmf3idph6q">
            ¿Qué vas a lograr con esta formación?
          </h2>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-155" data-mp="27v338gjokft2">
          {outcomes.map(({
          icon: Icon,
          title,
          description
        }, index) => <motion.article key={title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index * 0.1
        }} className="rounded-2xl border border-clay/15 bg-white p-7 shadow-sm" data-id="element-156" data-mp="1g2u93jbcbzjn" data-mpi={index}>
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-rose text-clay-dark" data-id="element-157" data-mp="30h4mst47zjwb">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-158" data-mp="2vjconhczf1jo" />
              </div>
              <h3 className="mt-6 font-heading text-2xl font-semibold leading-tight text-ink" data-id="element-159" data-mp="1t5ogys54pxuo">{title}</h3>
              <p className="mt-3 text-sm leading-6 text-ink/65" data-id="element-160" data-mp="1y3q902kj97ia">{description}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}